import React, { useState } from 'react';
import { style } from 'typestyle';
import * as styles from './cards.styles';
import DashboardUserModal from '../modals/dashboard-user-modal.component';
import { CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import type User from '../../authentication/models/user';

interface Props {
  readonly user: User;
  readonly handleDidDeleteUser: (user: User) => void;
}

const DashboardUserCard = ({ user, handleDidDeleteUser }: Props): React.JSX.Element => {
  const [showDashboardUserModal, setShowDashboardUserModal] = useState(false);

  return (
    <>
      <div
        className={style(styles.dashboardSubCard(true))}
        key={user.id}
        onClick={(): void => {
          setShowDashboardUserModal(true);
        }}
        role="presentation"
      >
        <Row crossAxisAlignment={CrossAxisAlignment.Center} itemSpacing={8}>
          <span className={style(styles.cardBody)}>{user.email}</span>
        </Row>
      </div>
      <DashboardUserModal
        showModal={showDashboardUserModal}
        user={user}
        handleDidDeleteUser={handleDidDeleteUser}
        handleClose={(): void => {
          setShowDashboardUserModal(false);
        }}
      />
    </>
  );
};

export default DashboardUserCard;
